import { createContext } from "react";

import type { DropInCallContextValue } from "./DropInCallContextValue";

export const DropInCallContext = createContext<DropInCallContextValue | null>(null);

DropInCallContext.displayName = "DropInCallContext";
